import { Fragment, type RefObject } from "react";
import { MessageBubble } from "./MessageBubble";
import type { LoadImage } from "./LazyImage";
import { dayKey, dateLabel } from "../format";
import type { CardState, ChatMessage } from "../protocol";

/** The message thread inside an open idea (no pagination — the whole thread loads). */
export function IdeaMessages({
  messages,
  endRef,
  scrollRef,
  onScroll,
  load,
  onOpen,
  onOpenDoc,
  onOption,
  cardStates,
  onCardDismiss,
}: {
  messages: ChatMessage[];
  endRef: RefObject<HTMLDivElement>;
  scrollRef?: RefObject<HTMLDivElement>;
  onScroll?: () => void;
  load: LoadImage;
  onOpen: (url: string) => void;
  onOpenDoc: (title: string, docId: string) => void;
  onOption: (text: string, extra?: { cardId?: string; optionId?: string }) => void;
  cardStates: Map<string, CardState>;
  onCardDismiss: (cardId: string) => void;
}) {
  // Resolve markers carry no prose — they only retract a card, so they must not become bubbles.
  const visible = messages.filter((m) => !m.sys);
  return (
    <div className="messages" ref={scrollRef} onScroll={onScroll}>
      {visible.map((m, i) => (
        <Fragment key={m.id}>
          {(i === 0 || dayKey(m.ts) !== dayKey(visible[i - 1].ts)) && (
            <div className="date-sep">
              <span>{dateLabel(m.ts)}</span>
            </div>
          )}
          <MessageBubble
            m={m}
            load={load}
            onOpen={onOpen}
            onOpenDoc={onOpenDoc}
            onOption={onOption}
            cardState={m.card ? cardStates.get(m.card.id) : undefined}
            onCardDismiss={onCardDismiss}
            quoted={m.replyTo ? (messages.find((x) => x.id === m.replyTo)?.text ?? "") : undefined}
          />
        </Fragment>
      ))}
      <div ref={endRef} />
    </div>
  );
}
